import { Benefit } from '@/features/login/components/benefit/benefit';
import { FastForward, Receipt, Tag } from '@phosphor-icons/react';

const benefits = [
  {
    text: 'discount',
    Icon: Tag,
  },
  {
    text: 'order_management',
    Icon: Receipt,
  },
  {
    text: 'faster_checkout',
    Icon: FastForward,
  },
];

export const Benefits = () => {
  return (
    <div className="flex flex-col gap-xxs no-flex-gap:space-y-xxs">
      {benefits.map(({ text, Icon }) => (
        <Benefit key={text} text={text} Icon={Icon} />
      ))}
    </div>
  );
};
